<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4"
                            :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-4' : 'md:grid-cols-3',
                            ]">
                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                    placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="カテゴリ">
                                <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="アイテム名">
                                <AutoCompleteInput v-model="searchForm.name" placeholder="アイテム名を入力"
                                    storage-key="material-name-history" :max-history-items="15"
                                    ref="materialNameInput" />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                        placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="カテゴリ">
                                    <CategorySelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.category_id" placeholder="カテゴリを選択" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="アイテム名">
                                        <AutoCompleteInput v-model="searchForm.name" placeholder="アイテム名を入力"
                                            storage-key="material-name-history" :max-history-items="15"
                                            ref="materialNameInput" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <div class="flex flex-grow md:hidden">
                        <el-button v-if="!isGrid" @click="updateGridMode(true)" circle>
                            <span class="material-symbols-outlined">
                                lists
                            </span>
                        </el-button>

                        <el-button v-else @click="updateGridMode(false)" circle>
                            <span class="material-symbols-outlined">
                                grid_view
                            </span>
                        </el-button>
                    </div>

                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info" @click="handleAddButton" circle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info" @click="handleAddButton">新規登録</el-button>

                    <el-upload v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" class="" ref="upload" :on-change="handleImportButton" :auto-upload="false"
                        :show-file-list="false" accept=".csv">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                                </span>
                            </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" @click="handleExportButton" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>

                    <div class="hidden md:block ml-3">
                        <el-button v-if="!isGrid" class="w-12" style="background-color: #ffffff;" text bg
                            @click="updateGridMode(true)">
                            <el-icon>
                                <span class="material-symbols-outlined mt-1">lists</span>
                            </el-icon>
                        </el-button>

                        <el-button v-else class="w-12 hidden md:block" style="background-color: #ffffff;" text bg
                            @click="updateGridMode(false)">
                            <el-icon>
                                <span class="material-symbols-outlined mt-1">grid_view</span>
                            </el-icon>
                        </el-button>
                    </div>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>アイテムマスタ（品名　カテゴリ　JANコード）</span>
                    <span class="ml-auto">
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('name')"
                                :class="['mobile-sort-btn', sortField === 'name' ? 'active' : '']">
                                アイテム名    
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('category_name')"
                                :class="['mobile-sort-btn', sortField === 'category_name' ? 'active' : '']">
                                カテゴリ    
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('jancode')"
                                :class="['mobile-sort-btn', sortField === 'jancode' ? 'active' : '']">
                                JANコード    
                            </el-button>
                            <span>アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </span>
                </div>

                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <template v-if="!isGrid">
                        <el-card style="border: 1px solid #d1d5db; border-radius: 0px" v-for="item in mTableData"
                            :key="item.material_code">
                            <el-row align="middle">
                                <el-col :span="2">
                                    <el-button class="w-8 h-16" type="info" style="background-color: #b7b7b7;" text bg
                                        @click="handleEditButton(item)">
                                        <span>詳<br>細</span>
                                    </el-button>
                                </el-col>

                                <el-col :span="18" class="ml-2">
                                    <div v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                    <div>{{ item.name }}</div>
                                    <el-row justify="space-between">
                                        <div>{{ item.category_name }}</div>
                                        <div>{{ item.jancode }}</div>
                                    </el-row>
                                    <div v-if="item.unit" class="text-sm text-gray-500">単位: {{ item.unit }}</div>
                                </el-col>

                                <el-col :span="2" class="ml-2" align="right">
                                    <span class="material-symbols-outlined cursor-pointer"
                                        @click="handleDeleteButton(item)">
                                        delete
                                    </span>
                                </el-col>
                            </el-row>
                        </el-card>
                    </template>

                    <template v-else>
                        <div class="flex flex-wrap gap-4 p-4">
                            <el-card
                                style="width: 100%; border: 2px solid #d1d5db; border-radius: 10px; position: relative;"
                                v-for="item in mTableData" :key="item.material_code">
                                <div class="absolute top-0 right-1.5 z-10">
                                    <el-button link @click="handleDeleteButton(item)">
                                        <el-icon>
                                            <Close />
                                        </el-icon>
                                    </el-button>
                                </div>

                                <div v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                <div class="flex flex-col justify-between">
                                    <div>{{ item.name }}</div>
                                    <el-row justify="space-between">
                                        <div>{{ item.category_name }}</div>

                                        <div>{{ item.jancode }}</div>
                                    </el-row>
                                    <div v-if="item.unit" class="text-sm text-gray-500">単位: {{ item.unit }}</div>
                                </div>

                                <div class="my-2 h-[160px]" align="center">
                                    <ImgLoading v-if="item.images" v-model="item.images" class="carousel-image" />
                                    <div v-else class="w-full h-full bg-gray-100"></div>
                                </div>

                                <div class="flex justify-center">
                                    <el-button class="w-12" type="info" style="background-color: #b7b7b7;" text bg
                                        @click="handleEditButton(item)">
                                        <span>詳細</span>
                                    </el-button>
                                </div>
                            </el-card>
                        </div>
                    </template>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table v-if="!isGrid" :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="アイテムマスタ" width="130" align="center">
                        <template #default="scope">
                            <el-button class="w-12" type="info" style="background-color: #b7b7b7;" text bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="所属組織"
                        width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="category_name" label="カテゴリ" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_name')">
                                <span>{{ getSortLabel('category_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_name' }">
                                        {{ getSortIcon('category_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="name" label="品名" min-width="400">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('name')">
                                <span>{{ getSortLabel('name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'name' }">
                                        {{ getSortIcon('name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ scope.row.name }}<br />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="jancode" label="JANコード" min-width="100">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('jancode')">
                                <span>{{ getSortLabel('jancode') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'jancode' }">
                                        {{ getSortIcon('jancode') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            <span v-if="scope.row.jancode" class="text-sm text-gray-500">
                                {{ scope.row.jancode }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="maker" label="メーカー" width="280">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('maker')">
                                <span>{{ getSortLabel('maker') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'maker' }">
                                        {{ getSortIcon('maker') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="expiration_day" label="初期期限" width="100" header-align="center" align="right">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('expiration_day')">
                                <span>{{ getSortLabel('expiration_day') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'expiration_day' }">
                                        {{ getSortIcon('expiration_day') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="{ row }">
                            {{ row.expiration_day + "日" }}
                        </template>
                    </el-table-column>



                    <el-table-column prop="unit" label="単位" width="100" align="center">
                    </el-table-column>

                    <el-table-column prop="" label="画像" width="52" align="center">
                        <template #default="scope">
                            <ImgLoading v-model="scope.row.images" class="thumbnail" />
                        </template>
                    </el-table-column>

                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>

                <div v-else v-loading="loading" style="height: calc(100vh - 260px)">
                    
                    <div class="custom-title flex items-center" style="height: 40px;">
                        <span>アイテムマスタ（品名　カテゴリ　JANコード）</span>
                        <span></span>
                    </div>

                    <div style="overflow-y: auto; height: calc(100vh - 270px)">
                        <div class="flex flex-wrap gap-4 p-4">
                            <el-card
                                style="width: 250px; border: 2px solid #d1d5db; border-radius: 10px; position: relative;"
                                v-for="item in mTableData" :key="item.material_code">
                                <div class="absolute top-0 right-1.5 z-10">
                                    <el-button link @click="handleDeleteButton(item)">
                                        <el-icon>
                                            <Close />
                                        </el-icon>
                                    </el-button>
                                </div>

                                <div v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                <div class="h-[100px] flex flex-col justify-between">
                                    <div>{{ item.name }}</div>
                                    <el-row justify="space-between">
                                        <div>{{ item.category_name }}</div>

                                        <div>{{ item.jancode }}</div>
                                    </el-row>
                                    <div v-if="item.unit" class="text-sm text-gray-500">単位: {{ item.unit }}</div>
                                </div>

                                <div class="my-2 h-[160px]" align="center">
                                    <ImgLoading v-if="item.images" v-model="item.images" class="carousel-image" />
                                    <div v-else class="w-full h-full bg-gray-100"></div>
                                </div>

                                <div class="flex justify-center">
                                    <el-button class="w-12" type="info" style="background-color: #b7b7b7;" text bg
                                        @click="handleEditButton(item)">
                                        <span>詳細</span>
                                    </el-button>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                        @current-change="handlePageChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <!-- 添加/编辑对话 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="dialogFormVisible" :title="form.add_update === 'add' ? '新規登録' : '詳細'" align-center>

        <div class="flex flex-col md:flex-row">

            <!-- 左侧图片预览 -->
            <div class="w-full md:w-1/3">
                <div class="relative" v-loading="imageLoading">
                    <el-upload class="p-2" drag action="#" :auto-upload="false" :on-change="handleImageChange"
                        :show-file-list="false" accept=".jpg,.jpeg,.png,.webp,.gif">
                        <img v-if="imageUrl" :src="imageUrl" class="w-full h-fill object-cover" />
                        <el-icon v-else>
                            <UploadFilled />
                        </el-icon>
                        <div class="el-upload__text">
                            ドラッグ＆ドロップまたは <em>クリック</em> して画像をアップロード
                        </div>
                    </el-upload>
                </div>
            </div>

            <!-- 右侧表单 -->
            <div class="w-full md:w-2/3">
                <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
                    <el-form-item label="コード" prop="material_code" hidden>
                        <el-input v-model="form.material_code" autocomplete="off"
                            :disabled="form.add_update === 'update'" placeholder="コード" />
                    </el-form-item>
                    <el-form-item label="アイテム名" prop="name">
                        <el-input v-model="form.name" autocomplete="off" placeholder="アイテム名" />
                    </el-form-item>
                    <el-form-item label="JANコード" prop="jancode" :error="errors.jancode">
                        <el-input v-model="form.jancode" autocomplete="off" placeholder="JANコード">
                            <template #append>
                                <el-button style="background-color: rgb(76, 175, 80); 
                                               color: white; 
                                               border: none;
                                               height: 100%;
                                               margin: 0;
                                               padding: 0 8px;
                                               border-right: 1px solid #dcdfe6;" @click="handleScanStart">
                                    スキャンを開始</el-button>
                                <el-button style="background-color: rgb(21, 96, 130); 
                                               color: white; 
                                               border: none;
                                               height: 100%;
                                               margin: 0;
                                               padding: 0 8px;
                                               border-radius: 0 4px 4px 0;"
                                    @click="handleJancodeSearch(form.jancode)">検索</el-button>

                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="所属組織" prop="organization_id" v-if="loginUserRole === ROLES.SYSTEM">
                        <OrganizationSelect v-model="form.organization_id" placeholder="組織を選択"
                            :disabled="form.add_update === 'update'" />
                    </el-form-item>
                    <el-form-item label="カテゴリ" prop="category_id">
                        <CategorySelect :organization-id="form.organization_id" v-model="form.category_id"
                            placeholder="カテゴリを選択" />
                    </el-form-item>
                    <el-form-item label="メーカー">
                        <el-input v-model="form.maker" autocomplete="off" placeholder="メーカー" />
                    </el-form-item>
                    <el-form-item label="詳細">
                        <el-input v-model="form.description" type="textarea" :rows="3" autocomplete="off"
                            placeholder="サイズ: ？cm x ？cm x ？cm, 内容物: ？,容量: ？, 色: ？, 包装: ？　など" />
                    </el-form-item>
                    <el-form-item label="初期期限">
                        <el-radio-group v-model="expiryMode" @change="handleExpiryModeChange">
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-2 flex-wrap">
                                    <el-radio label="days">有効期限</el-radio>
                                    <template v-if="expiryMode === 'days'">
                                        <el-input-number v-model="form.expiration_day" :min="0" :max="NO_EXPIRY_DAY - 1" placeholder="初期期限" />
                                        <span>日</span>
                                    </template>
                                </div>
                                <el-radio label="none">無期限</el-radio>
                            </div>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="単位" prop="unit">
                        <el-select v-model="form.unit" placeholder="単位を選択" clearable>
                            <el-option label="個" value="個" />
                            <el-option label="箱" value="箱" />
                            <el-option label="枚" value="枚" />
                            <el-option label="本" value="本" />
                            <el-option label="セット" value="セット" />
                        </el-select>
                    </el-form-item>
                </el-form>


            </div>
        </div>
        <div class="flex flex-col w-full">
            <div class="barcode-scanner-container" v-if="barcodeScannerState">
                <BarcodeScanner 
                    ref="barcodeScannerRef" 
                    @code-scanned="handleJancodeSearch" 
                    @scan-stopped="barcodeScannerState = false" 
                />
            </div>
        </div>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    {{ form.add_update === 'add' ? '登録' : '更新' }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>


<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, ElUpload } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import type { UploadInstance, UploadFile, FormInstance, FormRules } from 'element-plus'
import { Delete, Edit, Search, Plus, UploadFilled, Close, Camera } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus, UploadImageResponseData, ImportResponseData } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import BarcodeScanner from '@/components/common/BarcodeScanner.vue';
import router from '@/router';
import moment from 'moment';
import { ALL, CSV_MAX_SIZE, IMG_MAX_SIZE, NO_EXPIRY_DAY, ROLES, ROUTES, screenWidth } from '@/config/constants';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import ImgLoading from '@/components/common/ImgLoading.vue';
import { sortingUtil, SortConfig } from '@/components/common/SortingUtil';
import { md5 } from 'js-md5';

interface MaterialInfo {
    add_update?: Operation,
    material_code: string;
    jancode: string;
    name: string;
    organization_id: string;
    organization_name?: string;
    category_id: string;
    maker: string;
    description?: string;
    expiration_day: number;
    unit?: string;
    images?: string;
    created_by?: string,
    created_date?: string,
    updated_by?: string,
    updated_date?: string,
    category_name?: string,
    imageUrl?: string,
}

export default defineComponent({
    name: 'MngMaterial',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        CategorySelect,
        BarcodeScanner, // 确保 BarcodeScanner 已正确定义并导入
        ElUpload,
        UploadFilled,
        Delete,
        Plus,
        Edit,
        Search,
        Close,
        OrganizationSelect,
        AutoCompleteInput,
        Camera,
        ImgLoading,
    },
    setup() {
        const isGrid = ref(false);

        const barcodeScannerRef = ref(null);

        const updateGridMode = (value: boolean) => {
            isGrid.value = value;
        }

        const searchForm = ref({
            category_id: ALL,
            organization_id: ALL,
            name: ''
        });

        const drawer = ref(false);

        const imageUrl = ref('');
        const imageFile = ref<UploadFile>();

        const upload = ref<UploadInstance>()

        const loading = ref<boolean>(true);

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const errors = ref({
            jancode: ''
        })

        const form = ref<MaterialInfo>({
            add_update: Operation.unknow,
            images: '',
            material_code: '',
            jancode: '',
            name: '',
            organization_id: '',
            category_id: '',
            maker: '',
            description: '',
            expiration_day: 0,
            unit: '個',
        });

        const sortConfig: SortConfig = {
            material_code: {
                label: 'コード',
                mobileLabel: 'コード',
                type: 'string',
                defaultOrder: 'asc'
            },
            name: {
                label: 'アイテム名',
                mobileLabel: 'アイテム名',
                type: 'string',
                defaultOrder: 'asc'
            },
            full_name: {
                label: 'アイテム名',
                mobileLabel: 'アイテム名',
                type: 'string',
                defaultOrder: 'asc'
            },
            organization_name: {
                label: '所属組織',
                mobileLabel: '所属組織',
                type: 'string',
                defaultOrder: 'asc'
            },
            category_name: {
                label: 'カテゴリ',
                mobileLabel: 'カテゴリ',
                type: 'string',
                defaultOrder: 'asc'
            },
            maker: {
                label: 'メーカー',
                mobileLabel: 'メーカー',
                type: 'string',
                defaultOrder: 'asc'
            },
            expiration_day: {
                label: '初期期限',
                mobileLabel: '初期期限',
                type: 'number',
                defaultOrder: 'asc'
            },
            jancode: {
                label: 'JANコード',
                mobileLabel: 'JANコード',
                type: 'string',
                defaultOrder: 'asc'
            },
        }

        const allMaterials = ref<MaterialInfo[]>([]);

        const {
            paginatedData: mTableData,
            totalRecords: mTotalRecords,
            totalPages: mTotalPages,
            currentPage: mCurrentPage,
            pageSize: mPageSize,
            handleSizeChange,
            handlePageChange,
            showMoreDataAlert,
            sortField,
            sortOrder,
            handleSort,
            getSortLabel,
            getSortIcon,
        } = sortingUtil(
            allMaterials,
            sortConfig,
        );
        
        // 对话框表示菲表示
        const dialogFormVisible = ref(false);

        const formRef = ref<FormInstance>();

        const validateJancode = (rule: any, value: any, callback: any): void => {
            // Clear any existing errors
            errors.value.jancode = '';
            
            if (!value) {
                callback();
                return;
            }

            // For form submission, only check for duplicates
            const duplicateParams = {
                organization_id: form.value.organization_id,
                jancode: value,
            };
            
            // For updates, allow the same JANcode
            if (form.value.add_update === Operation.update && form.value.jancode === value) {
                callback();
                return;
            }
            
            axios.get('/api/materials/jancode', { params: duplicateParams })
                .then((duplicateRes) => {
                    if (duplicateRes.status === ResponseStatus.SUCCESS && 
                        duplicateRes.data.code === ErrorCode.OK && 
                        duplicateRes.data.data.length > 0) {
                        callback(new Error(getErrorMessage(PageType.MATERIAL, ErrorCode.ALREADY_EXIST)));
                        return;
                    }
                    callback();
                })
                .catch(error => {
                    const errorMessage = error.response?.data?.message || 'JANコードの検証中にエラーが発生しました';
                    callback(new Error(errorMessage));
                });
        };

        const rules = ref<FormRules>({
            // material_code: [
            //     { required: true, message: 'コードを入力してください', trigger: 'blur' },
            //     { min: 1, max: 20, message: 'コードは1〜20文字の間で入力してください', trigger: 'blur' }
            // ],
            name: [
                { required: true, message: 'アイテム名を入力してください', trigger: 'blur' },
                { min: 2, max: 50, message: 'アイテム名は2〜50文字の間で入力してください', trigger: 'blur' }
            ],
            organization_id: [
                { required: true, message: '所属組織を選択してください', trigger: 'change' }
            ],
            category_id: [
                { required: true, message: 'カテゴリを選択してください', trigger: 'change' }
            ],
            jancode: [
                { validator: validateJancode, trigger: 'blur' },  // Remove required validation to allow null values
            ]
        });
        // 图片是否改变
        let imageFileChanged: boolean = false;

        const loginUserRole = localStorage.getItem('role');
        const loginUserOrganizationId = localStorage.getItem('organization_id');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        // Add a new state variable to track image loading
        const imageLoading = ref(false);

        // 添加ref
        const materialNameInput = ref<any>(null);

        // 条形码扫描器状态
        const barcodeScannerState = ref<boolean>(false);

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getMaterialList();

            updateGridMode(window.innerWidth < screenWidth); // 初始化时检查宽度
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;

            if (materialNameInput.value) {
                materialNameInput.value.submitValue();
            }
            getMaterialList();
        };

        const handleAddButton = () => {
            dialogFormVisible.value = true;
            imageFileChanged = false;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    material_code: '',
                    jancode: '',
                    name: '',
                    organization_id: loginUserRole === ROLES.SYSTEM ? '' : (loginUserOrganizationId ?? ''),
                    category_id: '',
                    maker: '',
                    description: '',
                    expiration_day: 0,
                    unit: '個',
                };
                syncExpiryModeFromForm();
                imageUrl.value = '';
                imageFile.value = undefined;

                // 重置条形码扫描器状态
                if (barcodeScannerRef.value) {
                    // 调用组件的方法来重置状态
                    (barcodeScannerRef.value as any).resetScannerState();
                    barcodeScannerState.value = false;
                }
            });
        };

        const handleEditButton = (row: MaterialInfo) => {
            dialogFormVisible.value = true;
            nextTick(async () => {
                formRef.value?.resetFields();
                imageFileChanged = false;
                form.value = {
                    add_update: Operation.update,
                    material_code: row.material_code,
                    jancode: row.jancode,
                    name: row.name,
                    organization_id: row.organization_id,
                    // quantity: row.quantity,
                    category_id: row.category_id,
                    maker: row.maker,
                    description: row.description,
                    expiration_day: row.expiration_day,
                    unit: row.unit || '個',
                };
                syncExpiryModeFromForm();
                if (row.images) {
                    imageLoading.value = true;
                    let bufImages = row.images.split(',');
                    imageUrl.value = await getImages(bufImages);
                    imageLoading.value = false;
                } else {
                    imageUrl.value = '';
                    imageFile.value = undefined;
                }

                // 重置条形码扫描器状态
                if (barcodeScannerRef.value) {
                    // 调用组件的方法来重置状态
                    (barcodeScannerRef.value as any).resetScannerState();
                    barcodeScannerState.value = false;
                }
            });
        };

        const handleDeleteButton = (row: MaterialInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteMaterial(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addMaterial();
                    } else if (form.value.add_update === Operation.update) {
                        updateMaterial();
                    }
                    dialogFormVisible.value = false;
                }
            });
        };

        /** jancode.xyz serves a placeholder JPEG with this MD5 when there is no real product photo. */
        const JANCODE_XYZ_PLACEHOLDER_IMAGE_MD5 = 'e6c46fb5f844f62867a84c87f9fbbeff';

        const isJancodeXyzProductImageUrl = (imageUrl: string): boolean => {
            try {
                const u = new URL(imageUrl);
                return /jancode\.xyz$/i.test(u.hostname) && u.pathname.includes('/images/');
            } catch {
                return false;
            }
        };

        /** Same pattern as server jancodeXyzLookup: product photo on jancode.xyz */
        const buildJancodeXyzFallbackImageUrl = (janRaw: string): string | null => {
            const jan = (janRaw || '').trim();
            if (!/^(?:\d{8}|\d{13})$/.test(jan)) {
                return null;
            }
            return `https://www.jancode.xyz/images/${jan}.jpg`;
        };

        const handleJancodeSearch = async (jancode: string) => {
            // Clear any existing jancode errors
            errors.value.jancode = '';
            
            // Reset form validation state
            formRef.value?.clearValidate('name');
            
            // Check if JANcode length is <= 6
            if (!jancode || jancode.length <= 6) {
                errors.value.jancode = 'JANコードは7文字以上で入力してください';
                return;
            }
            
            imageLoading.value = true;
            try {
                const jancodeInfo = await getJanCodeInfo(jancode);
                if (!jancodeInfo) {
                    imageLoading.value = false;
                    return;
                }

                form.value.name = jancodeInfo.itemName;
                form.value.jancode = jancodeInfo.codeNumber;
                form.value.maker = jancodeInfo.makerName;

                const jan = String(jancodeInfo.codeNumber || jancode || '').trim();
                const primaryUrl = String(jancodeInfo.itemImageUrl || '').trim();
                const xyzUrl = buildJancodeXyzFallbackImageUrl(jan);

                if (primaryUrl) {
                    const willTryXyz = Boolean(xyzUrl && xyzUrl !== primaryUrl);
                    const ok = await loadJancodeImage(primaryUrl, { silent: willTryXyz });
                    if (!ok && xyzUrl && xyzUrl !== primaryUrl) {
                        imageLoading.value = true;
                        await loadJancodeImage(xyzUrl);
                    }
                } else if (xyzUrl) {
                    await loadJancodeImage(xyzUrl);
                } else {
                    imageLoading.value = false;
                }
            } catch {
                imageLoading.value = false;
            }
        };

        /***** DB 操作 **************************/
        const getMaterialList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    category_id: searchForm.value.category_id === ALL ? '' : searchForm.value.category_id,
                    name: searchForm.value.name,
                };

                const res: AxiosResponse<ResponseData<MaterialInfo[]>> = await axios.get('/api/materials/search', { params });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData } = res.data;

                    allMaterials.value = (data || []).map((material: any) => ({
                        ...material,
                        full_name: material.name + '(' + material.material_code + ')',
                    }));
                    showMoreDataAlert(hasMoreData || false);
                } else {
                    ElMessage.error(getErrorMessage(PageType.MATERIAL, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.MATERIAL));
            } finally {
                loading.value = false;
            }
        };

        const addMaterial = async () => {
            try {
                //画像アップロード
                let images = [];
                if (imageFileChanged && imageFile.value) {
                    const imgaeInfos = await uploadImages();
                    if (imgaeInfos) {
                        for (const imgaeInfo of imgaeInfos) {
                            images.push(imgaeInfo.id);
                        }
                        form.value.images = images.join(',');
                    } else {
                        ElMessage.error('画像アップロード失敗しました。');
                        return;
                    }
                }

                const res: AxiosResponse<ResponseData<MaterialInfo>> = await axios.post('/api/materials', form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getMaterialList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.MATERIAL, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.MATERIAL));
            }
        };

        const updateMaterial = async () => {
            try {

                //画像アップロード
                let images = [];
                if (imageFileChanged && imageFile.value) {
                    const imgaeInfos = await uploadImages();
                    if (imgaeInfos) {
                        for (const imgaeInfo of imgaeInfos) {
                            images.push(imgaeInfo.id);
                        }
                        form.value.images = images.join(',');
                        imageFileChanged = false;
                    } else {
                        ElMessage.error('画像アップロード失敗しました。');
                        return;
                    }
                }

                const res: AxiosResponse<ResponseData<MaterialInfo>> = await axios.put(`/api/materials/${form.value.material_code}`, form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getMaterialList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.MATERIAL, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.MATERIAL));
            }
        };

        const deleteMaterial = async (row: MaterialInfo) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/materials/${row.material_code}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getMaterialList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.MATERIAL, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.MATERIAL));
            }
        };


        const getImages = async (image_ids: string[]) => {
            var imgUrl = '';
            for (const image_id of image_ids) {
                const res = await axios.get(`/api/images/download/${image_id}`, { responseType: 'blob' });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    const uid = parseInt(image_id);
                    imageFile.value = {
                        url: URL.createObjectURL(res.data),
                        uid: uid,
                        name: image_id,
                        raw: res.data,
                        status: 'ready'
                    };
                    // 预览(单张 本画面特定)
                    imgUrl = URL.createObjectURL(res.data);
                } else {
                    ElMessage.error('画像情報の取得に失敗しました。');
                }
            }

            return imgUrl;
        };

        const handleImageChange = (file: any) => {


            imageFileChanged = true;
            // 图片预览
            imageUrl.value = URL.createObjectURL(file.raw || new Blob())
            // 图片上传

            imageFile.value = file
        }


        const uploadImages = async () => {
            if (imageFile.value) {
                const formData = new FormData()
                formData.append('files', imageFile.value.raw || new Blob())
                //文件过大 100K
                if (imageFile.value.raw && imageFile.value.raw.size > IMG_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return '';
                }

                try {
                    const res: AxiosResponse<UploadImageResponseData> = await axios.post('/api/images/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        // ElMessage.success('画像アップロード成功')
                        return res.data.images; // 返回值
                    } else {
                        ElMessage.error('画像アップロード失敗');
                        return '';
                    }

                } catch (error) {
                    ElMessage.error('画像アップロード失敗');
                    return ''; // 返回值
                }
            } else {
                ElMessage.error('ファイルが無効です');
                return ''; // 返回值
            }
        }

        const handleExportButton = () => {
            ElMessageBox.confirm('アイテムマスタをエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportMaterial();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const exportMaterial = async () => {
            try {
                loading.value = true;
                const res: AxiosResponse<any> = await axios.post(`/api/materials/export`, {
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'アイテムマスタ_' + moment(new Date().toISOString()).format('YYYYMMDDHHmmss') + '.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            } finally {
                loading.value = false;
            }
        };

        const handleImportButton = (file: UploadFile) => {
            if (file.raw) {
                const formData = new FormData()
                formData.append('file', file.raw)

                //文件过大 100K
                if (file.raw.size > CSV_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return;
                }
                loading.value = true;
                axios.post('/api/materials/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res: AxiosResponse<ImportResponseData>) => {
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        getMaterialList();
                        ElMessage.success('CSVインポート成功');
                    } else {
                        ElMessage.error('CSVインポート失敗しました。');
                    }

                }).catch(error => {
                    ElMessage.error('CSVインポート失敗しました。');
                }).finally(() => {
                    loading.value = false;
                })
            } else {
                ElMessage.error('ファイルが無効です')
            }
        }

        /***** JANCODE API **************************/
        const getJanCodeInfo = async (code: string) => {
            try {
                const params = {
                    jancode: code,
                };

                const res: AxiosResponse<ResponseData<any>> = await axios.post('/api/external/jancode', params);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    return res.data.data;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        type LoadJancodeImageOpts = { silent?: boolean };

        /** Load image via server proxy; returns true when preview/file were set. */
        const loadJancodeImage = async (url: string, opts: LoadJancodeImageOpts = {}): Promise<boolean> => {
            const { silent = false } = opts;
            try {
                const res = await axios.get('/api/jancodes/fetchImage', {
                    params: { url: url }
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const imageData = res.data.data.imageData;
                    const contentType = res.data.data.contentType;

                    // Convert base64 to blob
                    const byteCharacters = atob(imageData);
                    const byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                        const slice = byteCharacters.slice(offset, offset + 512);

                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }

                    const blob = new Blob(byteArrays, { type: contentType });

                    if (isJancodeXyzProductImageUrl(url)) {
                        const buf = await blob.arrayBuffer();
                        const hex = md5.hex(buf as ArrayBuffer);
                        if (hex === JANCODE_XYZ_PLACEHOLDER_IMAGE_MD5) {
                            imageUrl.value = '';
                            imageFile.value = undefined;
                            imageFileChanged = false;
                            return false;
                        }
                    }

                    const jancodeImageFile = new File([blob], 'image.jpg', { type: contentType });

                    // Process the image as before
                    imageFileChanged = true;
                    imageUrl.value = URL.createObjectURL(blob);
                    imageFile.value = {
                        raw: Object.assign(jancodeImageFile, { uid: 1 }),
                        name: 'image.jpg',
                        uid: 1,
                        status: 'ready'
                    };
                    return true;
                }
                if (!silent) {
                    ElMessage.error(res.data.message || 'JANCODE画像情報の取得に失敗しました。');
                }
                imageUrl.value = '';
                imageFile.value = undefined;
                return false;
            } catch (error: any) {
                console.log('jancodeImage error:', error);
                imageUrl.value = '';
                imageFile.value = undefined;

                const errorMessage = error.response?.data?.message || 'JANCODE画像情報の取得に失敗しました。';
                if (!silent) {
                    ElMessage.error(errorMessage);
                }
                return false;
            } finally {
                imageLoading.value = false;
            }
        };

        type ExpiryMode = 'days' | 'none';
        const expiryMode = ref<ExpiryMode>('days');
        const lastExpirationDay = ref(0);

        const syncExpiryModeFromForm = () => {
            if (form.value.expiration_day === NO_EXPIRY_DAY) {
                expiryMode.value = 'none';
            } else {
                expiryMode.value = 'days';
                lastExpirationDay.value = form.value.expiration_day ?? 0;
            }
        };

        const handleExpiryModeChange = (mode: string | number | boolean) => {
            if (mode === 'none') {
                if (form.value.expiration_day !== NO_EXPIRY_DAY) {
                    lastExpirationDay.value = form.value.expiration_day;
                }
                form.value.expiration_day = NO_EXPIRY_DAY;
            } else {
                form.value.expiration_day = lastExpirationDay.value;
            }
        };

        const handleScanStart = () => {
            barcodeScannerState.value = true;
            
            // Wait for Vue to render the barcode scanner before starting it
            nextTick(() => {
                if (barcodeScannerRef.value) {
                    (barcodeScannerRef.value as any).startScanning();
                }
            });
        };

        return {
            loginUserRole,
            searchForm,
            upload,
            isGrid,
            loading,
            mTableData,
            mTotalPages,
            mTotalRecords,
            mCurrentPage,
            mPageSize,
            updateGridMode,
            size,
            disabled,
            background,
            handleExportButton,
            handleImportButton,
            handleJancodeSearch,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleSizeChange,
            handlePageChange,
            form,
            dialogFormVisible,
            handleAddUpdateSubmit,
            formRef,
            rules,
            handleImageChange,
            uploadImages,
            imageUrl,
            UploadFilled,
            barcodeScannerRef,
            ROLES,
            imageLoading,
            materialNameInput,
            handleScanStart,
            expiryMode,
            handleExpiryModeChange,
            NO_EXPIRY_DAY,
            Camera,
            barcodeScannerState,
            drawer,
            errors,
            sortField,
            sortOrder,
            handleSort,
            getSortLabel,
            getSortIcon,
            loginUserRoleIsHead,
        }
    }
});
</script>

<style scoped>
.thumbnail {
    width: 30px;
    height: 30px;
    object-fit: cover;
}

.carousel-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* 添加这些样式 */
.barcode-scanner-container {
    margin-top: 10px;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

:deep(.el-input-group__append) {
    padding: 0;
    margin: 0;
}

:deep(.el-input-group__append .el-button) {
    margin: 0;
    border-radius: 0 4px 4px 0;
}
</style>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>